import React, { Dispatch, SetStateAction, useContext, useEffect, useRef, useState } from "react";
import MaskBackground from "../maskBackground/maskBackground";
import './cantProximity.css'
import { useNavigate } from "react-router-dom";
import { TfiClose } from "react-icons/tfi";
import axios from "axios";
import line from "../../image/Menu/baseLine.webp"
import { AppContext } from "../../context/AppContext";
import { useClickOutside } from "../hook/clickOutside";
import {FaLocationArrow } from "react-icons/fa";
import { slugify } from "../types/types";
import { normalizeCitySearch } from "../../screen/HomeScreen/SearchPage/hookSearchPage";
import { GoSearch } from "react-icons/go";
import { FiInfo } from "react-icons/fi";
import { RestaurantContext } from "../../context/RestaurantContext";
import { IoMdPin } from "react-icons/io";

export interface cityProps {
    name:string,
    latitude:string,
    longitude:string,
}
interface ContainerShowCityProps {
    clickProximity?: () => void,
    suggestionsCity: cityProps[],
    setShowCity: Dispatch<SetStateAction<boolean>>,
    setSearchCity: Dispatch<SetStateAction<string>>,
    clearProximity:() => void,
    canApplyCity?: (city: CurrentCity) => void;

    cityCountMap?: Map<string, number>;
    setImpossibleCity:Dispatch<SetStateAction<boolean>>,
}

const ContainerShowCity:React.FC<ContainerShowCityProps> = ({clickProximity,suggestionsCity,setShowCity,setSearchCity,clearProximity,canApplyCity,cityCountMap,setImpossibleCity}) => {
    const navigate = useNavigate()
    const handleClick = (city:cityProps) => {
        const restaurantCount = cityCountMap?.get(normalizeCitySearch(city.name)) ?? 0;
        if (canApplyCity && restaurantCount === 0) {
            setImpossibleCity?.(true);
            return;
        }
        if(canApplyCity) {
            canApplyCity({name:city.name,slug:slugify(city.name)})
        }else {
            navigate(`/${slugify(city.name)}`);
            setSearchCity(city.name);
        }
        setImpossibleCity(false);
        setShowCity(false);
        clearProximity()
    }

    return (
        <>
            {clickProximity && <div className="elem pointer" onPointerDown={(e) => {e.preventDefault();clickProximity();navigate('/restaurants-a-proximite')}} >
                <FaLocationArrow size={13} />
                <p key={"city-1"}>À proximité</p>
            </div>}
            {
                suggestionsCity.length > 0 && <>
                    <div className="borderCity"></div>
                    {suggestionsCity.map((city, index) => {
                        const restaurantCount = cityCountMap?.get(normalizeCitySearch(city.name)) ?? 0;
                        const isImpossible = !!canApplyCity && restaurantCount === 0;

                        return <div className={`elem pointer ${isImpossible ? 'isLocked' : ''}`} key={"suggestionCity"+index} onPointerDown={(e) => {e.preventDefault();handleClick(city)}} >
                            <div className="containerIconSearchLoc">
                                <GoSearch size={13} />
                            </div>
                            <p key={"city-"+index}>
                                {city.name}
                                {canApplyCity && (
                                    <span className="citySuggestionCount">
                                        {` (${restaurantCount})`}
                                    </span>
                                )}
                            </p>
                        </div>
                    })}
                </>
            }
        </>
    )
}

type CurrentCity = {
    name: string;
    slug: string;
} | null;
interface CantProximityProx {
    setCantProximity: Dispatch<SetStateAction<boolean>>;
    canApplyCity?: (city: CurrentCity) => void;
    canClose?:boolean,
    showInputCity?:boolean,
    shouldLockBack?:boolean,
    isForProximity?:boolean,

}
const CantProximity:React.FC<CantProximityProx> = ({setCantProximity,canApplyCity,canClose=true,showInputCity=true,shouldLockBack=false,isForProximity=false}) => {
    const {setValueSearchCity,filterChoose,setFilterChoose,setSearchCity,setCoordonates} = useContext(AppContext)
    const {miniRestos} = useContext(RestaurantContext)
    const [suggestionsCity, setSuggestionsCity] = useState<cityProps[]>([])
    const [currentValueSearchCity,setCurrentValueSearchCity] = useState('')
    const [showCity,setShowCity] = useState(false)
    const refCity = useRef<HTMLDivElement |null>(null)
    const [impossibleCity,setImpossibleCity]=useState(false)
    useEffect(() => {
        if (!impossibleCity) return;

        const timeout = setTimeout(() => {
            setImpossibleCity(false);
        }, 4000);

        return () => clearTimeout(timeout);
    }, [impossibleCity]);
    useClickOutside(refCity, showCity, () => {
        setShowCity(false);
        setImpossibleCity(false)
    });
    const navigate = useNavigate()
    const close = () => {
        if(!shouldLockBack) navigate('/')
        
        setCantProximity(false)
        setValueSearchCity('')
        setSearchCity('')
        setCoordonates({latitude: "",longitude: ""})
        setFilterChoose(filterChoose.filter(elem => elem!=='À proximité'))
    }
    useEffect(() => {
        if (currentValueSearchCity.length > 0) { 
            axios.post(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/getVille`, { name: currentValueSearchCity })
            .then(response => {
                setSuggestionsCity(response.data); 
            })
            .catch(error => {
                console.error('Erreur lors de la recherche des villes:', error);
            })
        } else {
            setSuggestionsCity([]); 
        }
    }, [currentValueSearchCity]);
    const handleClickCity = () => {
        setShowCity(true)
    }
    const changeSearchCityBar = (event: React.ChangeEvent<HTMLInputElement>) => {
        const v = event.target.value;
        setCurrentValueSearchCity(v)
        setImpossibleCity(false);
    }
    const clearProximity = () => {
        setCantProximity(false)
        if (filterChoose.includes('À proximité')) {
            setFilterChoose(prev => prev.filter(x => x !== 'À proximité'));
        } 
    }
    const cityCountMap = React.useMemo(() => {
        const map = new Map<string, number>();

        for (const resto of miniRestos) {
            const keys = new Set([resto._addressCityNorm,resto._visibleCityNorm]);
            keys.forEach((key) => {
                if (!key) return;
                map.set(key,(map.get(key) || 0) + 1);
            });
        }

        return map;
    }, [miniRestos]);

    return <>
        <div className="popUpCantProximity primaryBack" data-nosnippet>
            <TfiClose className="lowOpacityHover pointer close" size={15} onClick={close}></TfiClose>
            <p className="midTitle">Votre localisation est désactivée</p>
            <img src={line} />
            <p className="smallText textExplain">L’accès à la localisation est bloqué. Autorisez-la dans votre navigateur puis cliquez sur <span style={{whiteSpace:'nowrap'}}>« Actualiser »</span>.</p>
            {showInputCity && <div className="smallText tips" >
                Vous pouvez aussi rechercher directement une ville ci-dessous.
            </div>}
            {showInputCity && <div className="containerInput" ref={refCity}>
                <div className={`containerInputCity ${showCity &&  'select'}`} onClick={handleClickCity} >
                    <GoSearch color="black" opacity="85%" className="iconSearchProx" size={16} />
                    <input type="search" className="inputCity midText" id={"inputCity"} placeholder="Rechercher une ville..." style={{backgroundColor:"transparent"}} value={currentValueSearchCity} onChange={changeSearchCityBar} maxLength={50} autoComplete="new-password" name="q_addr" onFocus={(e) => {e.currentTarget.setAttribute('autocomplete', 'new-password')}}/>
                        {currentValueSearchCity && (
                    <TfiClose className="resetInput pointer" size={13} onClick={(e) => {e.stopPropagation();e.preventDefault();setCurrentValueSearchCity('') }}/>)} 
                </div>
                {showCity && suggestionsCity && suggestionsCity.length > 0 && <div className="containerListCity smallText" >
                        <ContainerShowCity setImpossibleCity={setImpossibleCity} cityCountMap={cityCountMap} setSearchCity={setValueSearchCity} suggestionsCity={suggestionsCity} setShowCity={setShowCity} clearProximity={() => clearProximity()} canApplyCity={canApplyCity}/>
                    </div>
                }
                {impossibleCity && showCity && <div className="containerCantCityProx smallText">
                    <FiInfo className='icon' />
                    <span>QuelResto n'est pas encore présent dans cette ville.</span>
                </div>}
            </div>}
            
            <div className="button XsmallText flexAllCenter">
                <div className="midWhiteButton" onClick={() => {if(isForProximity){window.location.href = "/restaurants-a-proximite";}else{window.location.reload()}}}>Actualiser</div>
            </div>
        </div>
        {shouldLockBack ? <div className="maskCantProximity" onClick={canClose ? () => close() : () => {}} ></div> : <MaskBackground zIndex={21} closeFunction={canClose ? () => close() : () => {}}/>}
    </>
}
export default CantProximity